import { createAction } from '@reduxjs/toolkit'
import { createReducer, createTypes } from 'reduxsauce'
import fetchApi from '../utils/fetch'

//
// ACTIONS
// -----------------------------------------------------------------------------

export const types = createTypes(`
  CERTIFICATES_INITIAL
  CERTIFICATES_SUCCESS
  CERTIFICATES_ERROR
  CERTIFICATES_FETCH_SUCCESS
  CERTIFICATES_FETCH_FAILURE
  CERTIFICATE_CLAIM_SUCCESS
  CERTIFICATE_CLAIM_FAILURE
`)

export const certificatesStatus = {
  initial: types.CERTIFICATES_INITIAL,
  success: types.CERTIFICATES_SUCCESS,
  error: types.CERTIFICATES_ERROR
}

//
// REDUCER
// -----------------------------------------------------------------------------

export const INITIAL_STATE = {
  status: certificatesStatus.initial,
  // null until the first fetch resolves; then an array of certificates
  // (claimed ones have an id and downloadUrl, claimable completions don't)
  list: null
}

// The backend list endpoint returns a bare array; fetchHelper spreads it into
// an object with numeric keys, so restore it with Object.values.
export const successList = (state = INITIAL_STATE, action) => ({
  ...state,
  list: Object.values(action.payload),
  status: certificatesStatus.success
})

// Claim responds with the updated certificate; upsert it into the list so the
// claimable row (no id yet) becomes the claimed one without a refetch.
export const successClaim = (state = INITIAL_STATE, action) => ({
  ...state,
  list: (state.list || []).map((certificate) =>
    certificate.tutorial.slug === action.payload.tutorial.slug
      ? action.payload
      : certificate
  ),
  status: certificatesStatus.success
})

export const failure = (state = INITIAL_STATE) => ({
  ...state,
  status: certificatesStatus.error
})

export const HANDLERS = {
  [types.CERTIFICATES_FETCH_SUCCESS]: successList,
  [types.CERTIFICATES_FETCH_FAILURE]: failure,
  [types.CERTIFICATE_CLAIM_SUCCESS]: successClaim
}

export default createReducer(INITIAL_STATE, HANDLERS)

//
// ACTION CREATORS
// -----------------------------------------------------------------------------

export const certificatesFetchSuccess = createAction(
  types.CERTIFICATES_FETCH_SUCCESS
)
export const certificatesFetchFailure = createAction(
  types.CERTIFICATES_FETCH_FAILURE
)
export const certificatesFetch = fetchApi(
  '/certificates/',
  { method: 'GET' },
  certificatesFetchSuccess,
  certificatesFetchFailure
)

export const certificateClaimSuccess = createAction(
  types.CERTIFICATE_CLAIM_SUCCESS
)
export const certificateClaimFailure = createAction(
  types.CERTIFICATE_CLAIM_FAILURE
)
export const certificateClaim = fetchApi(
  '/certificates/claim/',
  { method: 'POST' },
  certificateClaimSuccess,
  certificateClaimFailure
)
